import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import type { FeatureOption } from "@/constants/features";
import { Pill } from "@/components/atoms/Pill";
function PillGroup(t0) {
  const $ = _c(12);
  const {
    title,
    items,
    label
  } = t0;
  if (items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== title) {
    t1 = <div className="font-semibold text-base md:text-lg text-foreground-heading mb-3">{title}</div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== items || $[3] !== label) {
    let t3;
    if ($[5] !== label) {
      t3 = t4 => {
        const {
          key,
          icon: Icon
        } = t4;
        return <Pill key={key} className="gap-1.5 px-3 py-1.5 text-sm"><Icon className="size-4" />{label(key)}</Pill>;
      };
      $[5] = label;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = items.map(t3);
    $[2] = items;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="flex flex-wrap gap-2">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <div className="mb-6 break-inside-avoid" data-sentry-component="PillGroup" data-sentry-source-file="RoomFeaturePills.tsx">{t1}{t3}</div>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
export function RoomFeaturePills(t0) {
  const $ = _c(19);
  const {
    room,
    house
  } = t0;
  const tFeatures = useTranslations("modules.listings.addRoomListing.features");
  const tRoomDetails = useTranslations("modules.listings.addRoomListing.roomDetails");
  const tHouseDetails = useTranslations("modules.listings.addRoomListing.houseDetails");
  let t1;
  if ($[0] !== tRoomDetails) {
    t1 = tRoomDetails("roomFeaturesTitle");
    $[0] = tRoomDetails;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== tFeatures) {
    t2 = key => tFeatures(key);
    $[2] = tFeatures;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== room || $[5] !== t1 || $[6] !== t2) {
    t3 = <PillGroup title={t1} items={room} label={t2} data-sentry-element="PillGroup" data-sentry-source-file="RoomFeaturePills.tsx" />;
    $[4] = room;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== tHouseDetails) {
    t4 = tHouseDetails("houseFeaturesTitle");
    $[8] = tHouseDetails;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== tFeatures) {
    t5 = key_0 => tFeatures(key_0);
    $[10] = tFeatures;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== house || $[13] !== t4 || $[14] !== t5) {
    t6 = <PillGroup title={t4} items={house} label={t5} data-sentry-element="PillGroup" data-sentry-source-file="RoomFeaturePills.tsx" />;
    $[12] = house;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t3 || $[17] !== t6) {
    t7 = <div className="pb-4 md:pb-8" data-sentry-component="RoomFeaturePills" data-sentry-source-file="RoomFeaturePills.tsx">{t3}{t6}</div>;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}